/* eslint-disable linebreak-style */
/* eslint-disable no-trailing-spaces */
import React from 'react'
import './App.css'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import ReduxThunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { Router } from 'react-router-dom'
import reducers from './reducers'

import Routes from './routes/index'

export const history = createBrowserHistory()

const componentEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const store = createStore(reducers, {}, componentEnhancers(applyMiddleware(ReduxThunk)))

function App () {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Routes />
      </Router>
    </Provider>
  )
}

const token = localStorage.getItem('Token')
const adminData = JSON.parse(localStorage.getItem('adminData'))
const permission = JSON.parse(localStorage.getItem('adminPermission'))

if (token) {
  store.dispatch({
    type: 'TOKEN_LOGIN',
    payload: {
      token,
      adminData,
      permission
    }
  })
  if (history.location.pathname === '/auth/login' || history.location.pathname === '/auth/forgotpassword') {
    history.push('/dashboard')
  } else {
    history.push({ pathname: history.location.pathname, search: history.location.search, state: history.location.state })
  }
} else {
  history.push({ pathname: history.location.pathname, search: history.location.search, state: history.location.state })
}

export default App
